import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useContextElement} from "../../context/Context";

export default function ProductCard({
                                        product,
                                        styleClass = "style-1",
                                        tooltipDirection = "left",
                                        textCenter = false,
                                        ratioClass = "",
                                    }) {

    const imageSrc = product.coverImage || product.images?.[0]?.coverImage || "/product-placeholder.png";
    const [currentImage, setCurrentImage] = useState(imageSrc);


    const hasStockFromVariants =
        Array.isArray(product?.variants)
            ? product.variants.some(v => (v?.quantity ?? 0) > 0 && (v?.isStock ?? true))
            : undefined;

    const isSoldOut =
        product?.isStock === false ||
        (product?.isStock == null && hasStockFromVariants !== undefined && !hasStockFromVariants);



    const {setCartLoading} = useContextElement();


    const {
        setQuickViewItem,
        addProductToCart,
        isAddedToCartProducts,
        fetchProductBySlug,
        reloadCart,
        setQuickViewLoading,  // 🔴 eksikti
        quickViewLoading,     // 🔴 eksikti
    } = useContextElement();



    useEffect(() => {
        setCurrentImage(imageSrc);
    }, [product]);

    const hideActions = (product.isOutofSale === true) || (isSoldOut === true);


    return (
        <div
            className={`card-product style-5 ${
                product.sizes?.length > 0 ? "card-product-size" : ""
            } ${product.isOutofSale || isSoldOut ? "out-of-stock" : ""} ${styleClass}`}
        >
            <div className={`card-product-wrapper ${ratioClass} `}>
                <Link to={`/product-detail/${product.slug}`} className="product-img">
                    <img
                        className="img-product lazyload"
                        alt="image-product"
                        src={imageSrc}
                        width={513}
                        height={729}
                    />
                    <img
                        className="img-hover lazyload"
                        data-src={product.coverImage}
                        alt="image-product"
                        src={imageSrc}
                        width={513}
                        height={729}
                    />
                </Link>

                {!hideActions && (
                    <>
                        <ul className="list-product-btn">
                            {!styleClass.includes("style-3") && (

                                <li>
                                    <a
                                        href="#"
                                        className={`hover-tooltip tooltip-${tooltipDirection} box-icon`}
                                        onClick={async (e) => {
                                            e.preventDefault();

                                            // 🌀 Spinner başlasın
                                            setCartLoading(true);

                                            // 🧩 Modal hemen AÇILSIN
                                            const modalEl = document.getElementById("shoppingCart");
                                            if (modalEl && window.bootstrap?.Offcanvas) {
                                                const instance = window.bootstrap.Offcanvas.getOrCreateInstance(modalEl);
                                                instance.show();
                                            }

                                            // ⏳ Veriyi getir
                                            const fullProduct = await fetchProductBySlug(product.slug);
                                            if (!fullProduct) {
                                                setCartLoading(false);
                                                return;
                                            }

                                            const sizePriority = ["M", "L", "S", "XL", "XS"];
                                            const variant = sizePriority
                                                .map(size => fullProduct.variants?.find(v => v.size === size && v.isStock))
                                                .find(Boolean);

                                            if (!variant) {
                                                console.warn("Stokta uygun beden bulunamadı.");
                                                setCartLoading(false);
                                                return;
                                            }

                                            await addProductToCart(fullProduct.slug, 1, variant.guid);
                                            await reloadCart();

                                            // ✅ Veri geldikten sonra spinner kapansın
                                            setCartLoading(false);
                                        }}
                                    >
                                        <span className="icon icon-cart2"/>
                                        <span className="tooltip">
      {isAddedToCartProducts(product.slug) ? "Already Added" : "Add to Cart"}
    </span>
                                    </a>
                                </li>

                            )}

                            <li>
                                <a
                                    href="#"
                                    className={`hover-tooltip tooltip-${tooltipDirection} box-icon quickview`}
                                    onClick={async (e) => {
                                        e.preventDefault();

                                        // 1️⃣ Loader başlasın
                                        setQuickViewLoading(true);
                                        setQuickViewItem(null); // ❗️önceki item varsa sıfırla

                                        // 2️⃣ Modal hemen gösterilsin
                                        const modalEl = document.getElementById("quickView");
                                        if (modalEl && window.bootstrap?.Modal) {
                                            const modalInstance = window.bootstrap.Modal.getOrCreateInstance(modalEl);
                                            modalInstance.show();
                                        }

                                        // 3️⃣ Veriyi getir
                                        const fullProduct = await fetchProductBySlug(product.slug);
                                        if (fullProduct) {
                                            setQuickViewItem(fullProduct);
                                        }

                                        // 4️⃣ Görseller yüklenince loader kapansın (Quickview.js içinde kontrol edilecek)
                                    }}
                                >
                                    <span className="icon icon-view"/>
                                    <span className="tooltip">Quick View</span>
                                </a>
                            </li>


                        </ul>
                        {product.sizes?.length > 0 && (
                            <ul className="size-box">
                                {product.sizes.map((size, index) => (
                                    <li className="size-item text-xs text-white" key={index}>
                                        {size}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </>
                )}
            </div>
            <div className={`card-product-info ${textCenter ? "text-center" : ""} `}>
                <Link
                    to={`/product-detail/${product.slug}`}
                    className="name-product link fw-medium text-md"
                >
                    {product.name}
                </Link>
                <p className="price-wrap fw-medium">
                    <span className="price-new text-primary">£{Number(product.totalPrice).toFixed(2)}</span>
                </p>
            </div>
        </div>
    );
}
